<template>
  <div class="answer">
    <ul class="answer__choices">
      <li class="answer__choice--a" v-on:click="selectItem(choices[0].id)" :class="{selected: isSelectedItem[1]}">
        <span>A</span><p>{{ choices[0].text }}</p>
      </li>
      <li class="answer__choice--b" v-on:click="selectItem(choices[1].id)" :class="{selected: isSelectedItem[2]}">
        <span>B</span><p>{{ choices[1].text }}</p>
      </li>
      <template v-if="choiceNum >= 3">
        <li class="answer__choice--c" v-on:click="selectItem(choices[2].id)" :class="{selected: isSelectedItem[3]}">
          <span>C</span><p>{{ choices[2].text }}</p>
        </li>
        <li class="answer__choice--d" v-on:click="selectItem(choices[3].id)" :class="{selected: isSelectedItem[4]}">
          <span>D</span><p>{{ choices[3].text }}</p>
        </li>
      </template>
    </ul>
    <div class="answer__button">
      <div v-if="isGotoResult" v-on:click="checkAnswer" class="btn-start">
        <img :src="`${staticPath}img/factory/test/btn_test_answer_ok.png`">
      </div>
      <div v-else class="btn-start">
        <img :src="`${staticPath}img/factory/test/btn_test_answer.png`">
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import '@/assets/scss/modules.scss';

  .answer__choice {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    padding: 5px;
    border-radius: 20px;
    color: #1c3a7f;
    background-color: #fff;

    span {
      width: 34px;
      height: 34px;
      padding: 8px;
      color: #fff;
      background-color: #ccc;
      border-radius: 50%;
      font-size: 1.15em;
      font-weight: bold;
      text-align: center;
    }

    p {
      flex: 1;
      padding-left: 15px;
      font-size: 1.0em;
      font-weight: bold;
    }
  }

  .answer__choice--a {
    @extend .answer__choice;

    span {
      background-color: #2d50a9;
    }

    &.selected {
      color: #fff;
      background-color: #2d50a9;
    }
  }

  .answer__choice--b {
    @extend .answer__choice;

    span {
      background-color: #2da94d;
    }

    &.selected {
      color: #fff;
      background-color: #2da94d;
    }
  }

  .answer__choice--c {
    @extend .answer__choice;

    span {
      background-color: #a9392d;
    }

    &.selected {
      color: #fff;
      background-color: #a9392d;
    }
  }

  .answer__choice--d {
    @extend .answer__choice;

    span {
      background-color: #a99c2d;
    }

    &.selected {
      color: #fff;
      background-color: #a99c2d;
    }
  }

  .answer__button {
    width: 200px;
    padding-top: 10px;
    margin: 0 auto;
  }
</style>

<script>
  import Constant from '@/constant';

  export default {
    name: 'AnswerChoices',
    props: ['choices', 'correctId'],

    data(){
      return {
        staticPath: Constant.STATICPATH,
        isSelectedItem: [],
        isGotoResult: false,
        choiceId: 0
      }
    },

    crated() {
      
    },

    computed: {

      choiceNum() {
        return this.choices.length;
      }
    },

    methods: {
      
      selectItem(choice_id) {

        this.isSelectedItem = [];

        this.$set(this.isSelectedItem, choice_id, true);

        this.isGotoResult = true;

        this.choiceId = choice_id;
      },

      checkAnswer() {

        if (this.correctId == this.choiceId) {
          // 正解
          this.$emit('check-answer', true);
        } else {
          // 不正解
          this.$emit('check-answer', false);
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Study/Parts/AnswerChoices.vue